import { IResponseState } from "../../../../../components/Modals/ResponseModal/module/constants";
import {
  IReportParameter,
  IReportParameterUnique,
} from "../../module/constants";

export interface IParameterSectionProps {
  changeLocation: (url: string) => {};
  parameters: IReportParameterUnique[];
  responseDelete: IResponseState;
  responseAddEditState: IResponseState;
  getParameters: () => void;
  delParameter: (p: IReportParameter) => void;
  postParameter: (p: IReportParameter) => void;
  putParameter: (p: IReportParameter) => void;
  loader: boolean;
}

export const REPORT_MGMT_PARAM_FORM_FILTER = "reportMgmtParamFormFilter";

export const STATE_IDENTIFIER = {
  PARAMETERS: "parameters",
  PARAM_DEL_STATE: "deleteState",
  PARAM_ADD_EDIT_STATE: "addEditState",
  LOADER_IDENTIFIER: "loader",
};
